import Brace from "backbone.brace";
import Model from "../models/breadcrumb";

const Collection = Brace.Collection.extend({
  model: Model,
});

export { Collection as default };
